import type { TFunction } from 'i18next';

/** Map Postgres/Supabase error codes to messages people can act on. */
export function friendlyError(e: unknown, t: TFunction): string {
  const err = e as { code?: string; message?: string; status?: number };
  switch (err.code) {
    case '42501':
      return t('errors.forbidden');
    case '23505':
      return t('errors.duplicate');
    case '23514':
      return err.message ?? t('errors.generic');
  }
  if (err.status === 403 && err.message === 'beta features are disabled')
    return t('settings.beta_off');
  if (err.status === 503) return t('ai.not_configured');
  if (err.status === 403) return t('errors.forbidden');
  if (err.message?.includes('row-level security')) return t('errors.forbidden');
  if (err.message === 'Failed to fetch' || err.message?.includes('NetworkError'))
    return t('errors.network');
  return err.message ?? t('errors.generic');
}
